<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="70%">
    <v-btn round small block dark color="teal darken-1" slot="activator">
      <span style="margin-right: 10px; font-weight: bold">{{ amount }}</span>
      <v-icon>group</v-icon>
    </v-btn>
    <v-card>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-card-title>
              {{ $t("schema.teams.unallocated") }}
            </v-card-title>
            <v-btn dark
              width="60%"
              color="blue-grey darken-3"
              v-for="(team, index) in unallocated"
              :key="team.id"
              :index="index"
              @click="assign(index, team)">
              {{ team.name }}
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6>
            <v-card-title>
              {{ $t("schema.teams.assigned") }}
            </v-card-title>
            <v-btn dark
              width="60%"
              :color="color(team.id)"
              v-for="(team, index) in assigned"
              :key="team.id"
              :index="index"
              @click="unassign(index, team)">
              {{ team.name }}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-divider style="margin-top: 15px"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-progress-circular
            indeterminate
            color="primary"
            style="margin-right: 10px"
            v-if="loading"
            ></v-progress-circular>
          <v-btn :disabled="loading" round color="secondary" @click="cancel">
            {{ $t("base.cancel") }}
          </v-btn>
          <v-btn :disabled="loading" round color="primary" @click="submit">
            {{ $t("base.submit") }}
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import MultiColor from '@/plugins/multicolor'

export default {
  props: [ 'schema_id', 'teamIds' ],
  data() {
    return {
      dialog: false,
      assigned: [],
      unallocated: [],
      loading: false
    }
  },
  computed: {
    amount() {
      return this.teamIds.length
    }
  },
  mounted() {
    this.allocateTeams()
  },
  methods: {
    color(id) {
      return MultiColor.pickColor(id)
    },
    allocateTeams() {
      this.$store.getters.teams.map(team => {
        if(this.teamIds.includes(team.id)) {
          this.assigned.push(team)
        } else {
          this.unallocated.push(team)
        }
      })
    },
    assign(index, team) {
      this.unallocated.splice(index, 1)
      this.assigned.push(team)
    },
    unassign(index, team) {
      this.assigned.splice(index, 1)
      this.unallocated.push(team)
    },
    cancel() {
      this.dialog = false
      this.assigned = []
      this.unallocated = []
      this.allocateTeams()
    },
    submit() {
      this.loading = true
      let newTeamIds = this.assigned.map(team => team.id)
      this.$store.dispatch("setSchemaTeams", {
        id: this.schema_id,
        teams: newTeamIds
      })
          .then(() => {
            this.loading = false,
                this.dialog = false,
                this.$emit('updateTeams', newTeamIds)
            this.$store.commit("setSnack", {
              message: this.$t("schema.teams.update-success-message"),
              color: "success"
            })
          }).catch(() => {
        this.loading = false
        this.$store.commit("setSnack", {
          message: this.$t("schema.teams.update-fail-message"),
          color: "error"
        })
      })
    }
  }
}
</script>

<style>
</style>
